export const primary = '#4288F0';
export const primaryLight = '#E7F2F7';
export const background = '#F4F9FB';
export const paper = '#fff';
export const text = '#060F14';
